import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { ItemConversa } from '../models/item-conversa';

@Injectable({
  providedIn: 'root'
})
export class ItemConversaService {

  constructor(private http: HttpClient) { }

  consultarComPaginacao(descri: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if (descri.length > 0) {
      parametros = parametros.set('descri', descri);
    }

    return this.http.get<any>(globals.apiUrl + '/api/ItemConversa/ListaPag',
      {
        params: parametros
      });
  }

  consultarLista() {
    return this.http.get<any>(globals.apiUrl + '/api/ItemConversa/Lista');
  }

  consultarPorId(id: number) {
    return this.http.get<any>(globals.apiUrl + '/api/ItemConversa/Buscar',
      { params: new HttpParams().set('id', id.toString()) });
  }

  salvar(vm: ItemConversa) {
    return this.http.post(globals.apiUrl + '/api/ItemConversa/Salvar', vm);
  }

  excluir(id: number) {
    return this.http.delete(globals.apiUrl + '/api/ItemConversa/Excluir',
      { params: new HttpParams().set('id', id.toString()) });
  }
}
